import { registeredTabsHandlers } from '@/global/components/view-layouts/tabs-layout/common/registered-tabs-handlers'
import { dateService, FORMATS } from '@/global/services/date'
import { api } from '@/global/services/api'
import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { makeFormData } from '../../helpers/formData'
import gridView from '@/global/components/grid/GridView.vue'
import documentsGridBlock from './DocumentsGridBlock.vue'
import vehicleDocumentMixin from '../../mixins/vehicleDocumentMixin'
import truncatedTextDisplay from '@/global/components/TruncatedTextDisplay.vue'
import { showDetailsAction, deleteAction, activationAction } from '@/global/components/table/helpers/tableActions'
import { getBooleanFromValue } from '@/global/utils/utils'
export default {
  name: 'Documents',

  data () {
    return {
      showDocumentsTable: true,
      showDocumentDetails: false,
      documentDetailsTitle: this.$t('fleet/vehicle.document'),
      documentDetailsBaseTitle: this.$t('fleet/vehicle.document'),
      documentEditState: false,
      documentCreateModeState: false,
      sendDocumentOnEmailDialogConfig: {
        openDialog: false,
        title: this.$t('fleet/vehicle/documents_tab.email_dialog_title'),
        positiveBtnText: this.$t('base.send'),
        negativeBtnText: this.$t('base.cancel'),
        callbackFn: () => this.sendEmail()
      },
      documentEmailId: null,
      documentEmailFormData: {},
      documentEmailValidationErrors: {},
      documentValidationErrors: {},
      documentsPermissions: {}
    }
  },

  mixins: [
    vehicleDocumentMixin
  ],

  computed: {
    documentsConfig () {
      return {
        title: this.$t('fleet/vehicle_document.documents'),
        key: 'documents',
        visible: getBooleanFromValue(this.permissions?.canReadVehicleDocument),
        validationErrors: this.documentValidationErrors,
        onTabChange: () => {
          this.showMainEditButtons = false
        },
        editUpdate: (event) => {
          const { edit } = event || {}
          this.documentEditState = !!edit
        },
        createModeUpdate: (event) => {
          const { createMode } = event || {}
          this.documentCreateModeState = !!createMode
        },
        tabContent: [
          // table view
          {
            component: this.tableGridComponent,
            visible: this.showDocumentsTable,
            apiConfig: {
              get: {
                module: 'fleet',
                route: 'vehicle-document',
                queryParams: {
                  vehicle_id: this.$route.params.id
                }
              }
            },
            rowDblClick: (event) => this.showDocumentEdit(event),
            mobileConfig: {
              title: this.$t('fleet/vehicle_document.documents')
            },
            title_and_back_config: {
              title: this.$t('fleet/vehicle_document.documents')
            },
            search_and_buttons_config: {
              newClick: () => this.onNewDocument(),
              showNewBtn: getBooleanFromValue(this.documentsPermissions?.canCreate)
            },
            gridConfig: {
              component: gridView,
              blockConfig: {
                component: documentsGridBlock,
                showDetails: () => {
                  this.showDocumentsTable = false
                  this.showDocumentDetails = true
                },
                setDetailsTitle: (val) => {
                  this.documentDetailsTitle = val
                }
              },
              useBorder: false
            },
            onDataReceivedWithParams: (event) => {
              this.documentsPermissions = event?.data?.meta?.permissions || {}
            },
            tableConfig: {
              cellsConfig: {
                issued: {
                  custom_display_value: (item) => {
                    return item?.issued ? dateService.formatFromUtc(item.issued, FORMATS.date) : ''
                  }
                },
                valid_until: {
                  custom_display_value: (item) => {
                    return item?.valid_until ? dateService.formatFromUtc(item.valid_until, FORMATS.date) : ''
                  }
                },
                images: {
                  wrapperStyle: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start'
                  }
                },
                alarm_on: {
                  style: {
                    justifyItems: 'center'
                  }
                }
              },
              headers: [
                {
                  label: this.$t('fleet/vehicle_document.name'),
                  key: 'name',
                  always_visible: true
                },
                {
                  label: this.$t('fleet/vehicle_document.identification_string'),
                  key: 'identification_string',
                  always_visible: true
                },
                {
                  label: this.$t('fleet/vehicle_document.issued'),
                  key: 'issued',
                  always_visible: true
                },
                {
                  label: this.$t('fleet/vehicle_document.issued_by'),
                  key: 'issued_by',
                  always_visible: true
                },
                {
                  label: this.$t('fleet/vehicle_document.valid_until'),
                  key: 'valid_until',
                  always_visible: true
                },
                {
                  label: this.$t('fleet/vehicle_document.images'),
                  key: 'images',
                  always_visible: true,
                  component: this.tableImageIconWithCounterComponent,
                  disableDefaultClick: true,
                  onClick: (event) => {
                    this.showFilesPreviewDialog({
                      ...event,
                      fieldKey: 'images',
                      removeApiConfig: {
                        module: 'fleet',
                        route: 'vehicle-document/remove-media/'
                      }
                    }, 'image', 'documents')
                  }
                },
                {
                  label: this.$t('fleet/vehicle_document.note'),
                  key: 'note',
                  always_visible: true,
                  component: truncatedTextDisplay
                },
                {
                  label: this.$t('fleet/vehicle_document.status'),
                  key: 'status',
                  always_visible: true,
                  component: this.activeIconComponent
                },
                {
                  label: this.$t('fleet/vehicle_document.alarm_on'),
                  key: 'alarm_on',
                  always_visible: true,
                  component: this.cellIconComponent,
                  style: {
                    textAlign: 'center'
                  },
                  src: (event) => {
                    const { data } = event || {}
                    return data === 1 ? '/img/icons/green-check-circle.svg' : '/img/icons/grey-check-circle.svg'
                  }
                }
              ],
              actionsConfig: [
                showDetailsAction(this.$t, (event) => this.showDocumentEdit(event), { visible: getBooleanFromValue(this.documentsPermissions?.canRead) }),
                {
                  label: this.$t('fleet/vehicle/documents_tab.send_to_email_button_label'),
                  src: '/img/icons/email-send-action-icon.svg',
                  click: (event) => this.onDocumentSendEmail(event)
                },
                activationAction(this.$t, (event) => this.onDocumentActivation(event), (event) => !!event?.data?.status),
                deleteAction(this.$t, (event) => this.onDocumentDeletion(event), { visible: getBooleanFromValue(this.documentsPermissions?.canDelete) })
              ],
              paginationConfig: {
                perPageOptions: [50, 100]
              },
              filtersConfig: {
                fields: [
                  {
                    key: 'name',
                    label: this.$t('fleet/vehicle_document.name'),
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'identification_string',
                    label: this.$t('fleet/vehicle_document.identification_string'),
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'issued',
                    label: this.$t('fleet/vehicle_document.issued'),
                    type: 'datetime-picker',
                    subType: 'date',
                    appendIcon: 'mdi-calendar-month',
                    format: FORMATS.date,
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'issued_by',
                    label: this.$t('fleet/vehicle_document.issued_by'),
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'valid_until',
                    label: this.$t('fleet/vehicle_document.valid_until'),
                    type: 'datetime-picker',
                    subType: 'date',
                    appendIcon: 'mdi-calendar-month',
                    format: FORMATS.date,
                    visible: true,
                    editable: true
                  }
                ]
              }
            }
          },
          // details view
          {
            component: this.tabActionsComponent,
            visible: this.showDocumentDetails,
            title: this.documentDetailsTitle,
            showEditButtons: true,
            showEditBtn: getBooleanFromValue(this.documentsPermissions?.canUpdate),
            showBackButton: {
              onGoBack: () => this.exitFromDocumentDetails()
            },
            onCancelTabSave: () => this.exitFromDocumentDetails(true),
            onSaveClick: () => this.onSaveDocument()
          },
          {
            component: this.columnsContentComponent,
            visible: this.showDocumentDetails,
            showBackButton: {
              useChangesNotSavedDialog: false
            },
            rows: [
              {
                disabled: !getBooleanFromValue(this.documentsPermissions?.canUpdate),
                columnsCount: 3,
                fields: [
                  {
                    key: 'name',
                    label: this.$t('fleet/vehicle_document.name'),
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'identification_string',
                    label: this.$t('fleet/vehicle_document.identification_string'),
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'issued',
                    label: this.$t('fleet/vehicle_document.issued'),
                    type: 'datetime-picker',
                    subType: 'date',
                    appendIcon: 'mdi-calendar-month',
                    disableFutureDates: true,
                    format: FORMATS.date,
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !dateService.isValid(value, FORMATS.date, true)) {
                        updateValidationErrors({
                          issued: this.$t('base.invalid_date').replace(':format', FORMATS.date)
                        })
                      }
                    },
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'issued_by',
                    label: this.$t('fleet/vehicle_document.issued_by'),
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'valid_until',
                    label: this.$t('fleet/vehicle_document.valid_until'),
                    type: 'datetime-picker',
                    subType: 'date',
                    appendIcon: 'mdi-calendar-month',
                    format: FORMATS.date,
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !dateService.isValid(value, FORMATS.date, true)) {
                        updateValidationErrors({
                          valid_until: this.$t('base.invalid_date').replace(':format', FORMATS.date)
                        })
                      }
                    },
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'images',
                    label: this.$t('fleet/vehicle/documents_tab.uploaded_images_label'),
                    type: 'files_preview',
                    subtype: 'image',
                    src: '/img/icons/table-image-icon.svg',
                    click: (event) => {
                      this.showFilesPreviewDialog({
                        ...event,
                        fieldKey: 'images',
                        removeApiConfig: {
                          module: 'fleet',
                          route: 'vehicle-document/remove-media/'
                        }
                      }, 'image', 'documents')
                    },
                    visible: !this.documentEditState && !this.documentCreateModeState,
                    editable: true
                  },
                  {
                    key: 'images_upload',
                    label: this.$t('fleet/vehicle_document.images'),
                    type: 'files_upload',
                    subtype: 'image',
                    accept: '/image*',
                    src: '/img/icons/table-image-icon.svg',
                    click: (event) => {
                      this.showFilesPreviewDialog({
                        ...event,
                        fieldKey: 'images_upload'
                      }, 'image', 'documents')
                    },
                    visible: this.documentEditState || this.documentCreateModeState,
                    editable: true,
                    readonly: true
                  },
                  {
                    key: 'note',
                    label: this.$t('fleet/vehicle_document.note'),
                    type: 'textarea',
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'alarm_on',
                    label: this.$t('fleet/vehicle_document.alarm_on'),
                    type: 'base-switch',
                    visible: true,
                    editable: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    onNewDocument () {
      const { setCreateMode, clearData } = registeredTabsHandlers?.documents || {}
      if (typeof setCreateMode === 'function') {
        setCreateMode(true)
      }
      if (typeof clearData === 'function') {
        clearData()
      }
      this.documentDetailsTitle = this.$t('fleet/vehicle.new_document')
      this.showDocumentsTable = false
      this.showDocumentDetails = true
    },

    exitFromDocumentDetails (canceling = false) {
      const { clearData, setCreateMode, setEditMode, getCreateModeState, cancelSave } = registeredTabsHandlers?.documents || {}
      let isCreateMode = false
      if (typeof getCreateModeState === 'function') {
        isCreateMode = getCreateModeState()
      }

      if (isCreateMode) {
        this.showDocumentsTable = true
        this.showDocumentDetails = false

        if (typeof clearData === 'function') {
          clearData()
        }
        if (typeof setCreateMode === 'function') {
          setCreateMode(false)
        }
        if (typeof setEditMode === 'function') {
          setEditMode(false)
        }
      }
      else if (typeof cancelSave === 'function') {
        if (!canceling) {
          this.showDocumentsTable = true
          this.showDocumentDetails = false
        }

        cancelSave()
      }
      this.documentValidationErrors = {}
    },

    async onSaveDocument () {
      try {
        const { getFormData } = registeredTabsHandlers?.documents || {}
        const { fetchData } = registeredTableHandlers?.documents || {}
        const { id: vehicleId } = this.$route?.params || {}

        if (!vehicleId) return

        const data = typeof getFormData === 'function' ? getFormData()?.data : {}
        const formData = makeFormData(data,
          ['images_upload'],
          {
            vehicle_id: vehicleId
          },
          {
            issued: {
              fromFormat: FORMATS.date,
              toFormat: FORMATS.isoDate
            },
            valid_until: {
              fromFormat: FORMATS.date,
              toFormat: FORMATS.isoDate
            }
          })

        let apiUrl = 'vehicle-document'
        const { id: documentId } = data || {}
        if (!this.documentCreateModeState && documentId) {
          formData.append('_method', 'PATCH')
          apiUrl += `/${documentId}`
        }

        await api('fleet').post(apiUrl, formData)
        this.exitFromDocumentDetails()

        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        this.documentValidationErrors = exception?.response?.data?.errors || {}
        console.error(exception)
      }
    }
  }
}
